import Slider from "react-slick";

import CustomArrow from './CustomArrow';

import i18nService from '../../../services/i18nService';

export default function ModelSelector(props) {
  let modelSlides = []
  props.models.forEach(model => {
    modelSlides.push(
      <div key={model.id}
        className="Carousel-slide"
        onClick={() => props.selectModel(model)}
        >
        <div
          className="Carousel-slide-image"
          style={{ backgroundImage: `url(${model.production_cover})`}}
          />
        <h2 className="Carousel-slide-title">
          <span className="Carousel-slide-title-pre">{model.name_pre}</span> {model.name} <span className="Carousel-slide-title-post">{model.name_post}</span>
        </h2>
        <p className="Carousel-slide-price"><small>{i18nService.translate(props.locale, 'from')}</small> {model.price_from}</p>
      </div>
    )
  })

  const slickSettings = {
    dots: true,
    speed: 500,
    slidesToScroll: 1,
    nextArrow: <CustomArrow direction='right' />,
    prevArrow: <CustomArrow direction='left' />
  };

  return (
    <div className="ModelSelector">
      <div className="desktop-only">
        <Slider {...slickSettings} infinite={false} slidesToShow={4}>{modelSlides}</Slider>
      </div>

      <div className="mobile-only">
        <Slider {...slickSettings} infinite={true} slidesToShow={1}>{modelSlides}</Slider>
      </div>
    </div>
  )
}
